// Logging a dose of anything (feedback #60, "what if I'm dosing something
// that's not in the list?"): trace elements, iodine, amino acids, nitrate
// or phosphate dosing, bacteria, another brand of alkalinity. TankSensei
// records it and never suggests an amount. Pure, shared by the route and
// the form.

export const DOSE_LOG_UNITS = [
  { k: 'ml', label: 'mL' },
  { k: 'drops', label: 'drops' },
  { k: 'g', label: 'g' },
  { k: 'tsp', label: 'tsp' },
  { k: 'capful', label: 'capful' },
];

export function doseLogUnitLabel(unit) {
  return DOSE_LOG_UNITS.find((u) => u.k === unit)?.label || unit || '';
}

const DAY = 86400000;

// Returns { ok: true, row } or { ok: false, error } with keeper-facing words.
export function validateDoseLog(body, { now = Date.now() } = {}) {
  const b = body && typeof body === 'object' ? body : {};
  const label = String(b.product_label ?? '')
    .trim()
    .slice(0, 80);
  if (!label) return { ok: false, error: 'Name the product you dosed.' };
  const amountRaw = b.amount;
  if (amountRaw === '' || amountRaw == null) return { ok: false, error: 'How much did you dose?' };
  const amount = Number(amountRaw);
  if (!Number.isFinite(amount) || amount <= 0 || amount > 100000) {
    return { ok: false, error: 'The amount must be a number above 0.' };
  }
  const unit = String(b.unit || '');
  if (!DOSE_LOG_UNITS.some((u) => u.k === unit)) return { ok: false, error: 'Pick a unit.' };
  const paramRaw = b.param == null || b.param === '' ? 'other' : String(b.param);
  if (!/^[a-z][a-z0-9_]{0,30}$/.test(paramRaw)) return { ok: false, error: 'Unknown parameter.' };
  let ts = now;
  if (b.ts != null && b.ts !== '') {
    const t = new Date(b.ts).getTime();
    if (!Number.isFinite(t)) return { ok: false, error: 'That date is not valid.' };
    if (t > now + 10 * 60000) return { ok: false, error: 'That time is in the future.' };
    if (t < now - 366 * DAY) return { ok: false, error: 'That date is more than a year ago.' };
    ts = t;
  }
  const note = b.note ? String(b.note).trim().slice(0, 300) : null;
  return {
    ok: true,
    row: { product_label: label, amount, unit, param: paramRaw, ts: new Date(ts), note },
  };
}
